// client/src/components/TiptapEditor/MenuBar/FormattingGroup.js
import React from "react";

export const FormattingGroup = ({ editor }) => {
  const buttons = [
    {
      name: "bold",
      action: () => editor.chain().focus().toggleBold().run(),
      label: "B",
    },
    {
      name: "italic",
      action: () => editor.chain().focus().toggleItalic().run(),
      label: "I",
    },
    {
      name: "underline",
      action: () => editor.chain().focus().toggleUnderline().run(),
      label: "U",
    },
  ];

  return (
    <>
      {buttons.map((button) => (
        <button
          key={button.name}
          type="button"
          onClick={button.action}
          className={editor.isActive(button.name) ? "is-active" : ""}
        >
          {button.label}
        </button>
      ))}
    </>
  );
};
